import { LoadableRoute } from 'routes/utils/loadable';

export const PublicCandidateProfileContainer = LoadableRoute({
  loader: () =>
    import(
      /* webpackChunkName: "PublicCandidateProfile" */ './PublicCandidateProfile'
    ),
});
